//Reset data
export const RESET = "STATISTIQUE_LIST_RESET"

//Loading
export const SET_TOGGLE_LOADING = "STATISTIQUE_LIST_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "STATISTIQUE_LIST_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "STATISTIQUE_LIST_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "STATISTIQUE_LIST_SET_MESSAGE"
export const SET_IS_SUCCESS = "STATISTIQUE_LIST_SET_IS_SUCCESS"
export const SET_IS_ERROR = "STATISTIQUE_LIST_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "STATISTIQUE_LIST_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "STATISTIQUE_LIST_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "STATISTIQUE_LIST_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "STATISTIQUE_LIST_SET_ITEMS"
export const SET_CURRENT_ITEM = "STATISTIQUE_LIST_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "STATISTIQUE_LIST_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "STATISTIQUE_LIST_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "STATISTIQUE_LIST_SET_HIDE_MODAL"


export const SET_MODAL = "STATISTIQUE_LIST_SET_MODAL"
export const SET_MODAL_CONTENT = "STATISTIQUE_LIST_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "STATISTIQUE_LIST_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "STATISTIQUE_LIST_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "STATISTIQUE_LIST_SET_MODAL_TYPE"